import React, { useCallback } from 'react';

import SatButton from '@components/common/satUI/SatButton';
import SatCheckBox from '@components/common/satUI/SatCheckBox';

const TermsAgree = props => {
  const {
    inputComplete,
    show3rdTelco,
    handleShowTerms,
    agreeCheckList,
    setAgreeCheckList,
    checkAgree2,
    setCheckAgree2,
  } = props;

  const handleClickTerms = useCallback(targetId => check => {
    if ('termsAll' === targetId) {
      setAgreeCheckList(Array(9).fill(check ? true : ''));
      setCheckAgree2(check);
    } else if ('terms1' === targetId) {
      setAgreeCheckList(Array(9).fill(check ? true : ''));
    } else if ('terms2' === targetId) {
      setCheckAgree2(check);
    }
  });

  const handleOnOk = () => {
    if (
      agreeCheckList.filter(value => value).length === agreeCheckList.length &&
      checkAgree2
    ) {
      inputComplete();
    }
  };

  return (
    <>
      <h3 className="layer-tit2">약관 동의</h3>
      <div className="agree-list modal-type">
        <div className="tit-area">
          <SatCheckBox
            type={'radio'}
            value={[
              agreeCheckList.filter(value => value).length ===
                agreeCheckList.length && checkAgree2,
            ]}
            options={[{ label: '모두 동의합니다.', value: 1 }]}
            onChange={handleClickTerms('termsAll')}
          />
        </div>
        <div className="tit-area">
          <SatCheckBox
            type={'radio'}
            value={[
              agreeCheckList.filter(value => value).length ===
                agreeCheckList.length,
            ]}
            options={[
              {
                label: () => {
                  return (
                    <>
                      [필수] 고객정보관리 및 가입 설계를 위한
                      <br />
                      상세 동의 (전체)
                      <br />
                      전문보기의 동의서를 모두 읽고 확인
                      <br />
                      하신 후 동의 해 주시기 바랍니다.
                    </>
                  );
                },
                value: 1,
              },
            ]}
            onChange={handleClickTerms('terms1')}
          />
          <span
            className="btn-view2"
            onClick={() => handleShowTerms('terms1')}
            style={{ cursor: 'pointer' }}
          >
            전문보기
          </span>
        </div>
        <div className="tit-area">
          <SatCheckBox
            type={'radio'}
            value={[checkAgree2]}
            options={[{ label: '휴대전화 본인인증 필수 항목 동의', value: 1 }]}
            onChange={handleClickTerms('terms2')}
          />
          <span
            className="btn-view2"
            onClick={() => handleShowTerms('terms2')}
            style={{ cursor: 'pointer' }}
          >
            전문보기
          </span>
        </div>
        <ul className="list-block">
          <li>개인정보 수집/이용 동의</li>
          <li>고유식별정보 처리 동의</li>
          <li>서비스 이용약관 동의</li>
          <li>통신사 이용약관 동의</li>
          <li style={{ visibility: show3rdTelco ? 'visible' : 'hidden' }}>
            알뜰폰 제3자 제공 동의
          </li>
        </ul>
      </div>
      <div className="btn-area">
        <SatButton
          styleClass="btn-l blue"
          label={'인증번호 받기'}
          onClick={handleOnOk}
          disabled={
            agreeCheckList.filter(value => value).length !==
              agreeCheckList.length || !checkAgree2
          }
        />
      </div>
    </>
  );
};

export default TermsAgree;
